<template>
  <div>
    <h2>Ação</h2>
    <form action="" class="md-layout" @submit.prevent="submit">
      <md-field :class="getValidationClass('botaoAcaoEquipamentoId')">
        <label for="actionViews">Ação</label>
        <md-select
          id="actionViews"
          v-model="botaoAcaoEquipamentoId"
          name="actionViews"
          md-dense
        >
          <md-option
            v-for="actionView in actionViews"
            :key="actionView.id"
            :value="actionView.id"
          >
            {{ actionView.equipamentoNome + ' - ' + actionView.nomeExibicao }}
          </md-option>
        </md-select>
        <span v-if="$v.botaoAcaoEquipamentoId" class="md-error"
          >Ação obrigatória</span
        >
      </md-field>
      <div style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => $emit('close')">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary">
          {{ isEdit ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import { ComponenteTipo } from '../../../utils/componente'
import http from '../../../utils/http'

export default {
  name: 'ViewActionForm',
  mixins: [validationMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      botaoAcaoEquipamentoId: null,
      actionViews: [],
    }
  },
  validations: {
    botaoAcaoEquipamentoId: { required },
  },
  computed: {
    isEdit() {
      return this.componente !== null
    },
  },
  async beforeMount() {
    if (this.componente !== null) {
      this.botaoAcaoEquipamentoId = this.componente.value.botaoAcaoEquipamentoId
    }

    this.actionViews = (
      await http.get(`local/${this.localId}/acao/botoes`)
    ).botoes
  },
  methods: {
    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const equipamentoNome = this.actionViews.find(
        (e) => e.id === this.botaoAcaoEquipamentoId
      ).equipamentoNome

      let response

      const value = {
        botaoAcaoEquipamentoId: this.botaoAcaoEquipamentoId,
        equipamentoNome: equipamentoNome,
      }

      if (this.isEdit) {
        response = await http.put(`/view/componente`, {
          id: this.componente.id,
          value: value,
          z: this.componente.z,
        })
      } else {
        response = await http.post(`/view/componente`, {
          tipo: ComponenteTipo.ActionView,
          viewId: this.viewId,
          value: value,
        })
      }

      if (response) {
        this.$emit('close')
        this.$emit('updated')
      }
    },
    getValidationClass(fieldName) {
      const field = this.$v[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
  },
}
</script>

<style scoped></style>
